import React from 'react';
import { connect } from 'react-redux';
import { get } from '~/actions/locations';
import FontIcon from 'react-toolbox/lib/font_icon';
import Spinner from '~/components/Spinner';
import style from './style.scss';

class Tag extends React.Component {
  static contextTypes = {
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: props.id && !props.item,
    };
  }

  componentDidMount() {
    if (this.state.loading) {
      get(this.props.dispatch, this.context.apiClient, this.props.id)
        .catch(() => false).then(() => this.setState({ loading: false }));
    }
  }

  render() {
    const { id, item, className, ...rest } = this.props;
    delete rest.dispatch;

    return (
      <div className={[style.tag, className, (this.state.loading || !item) && style.loading, item && item.get('removed') && style.removed].join(' ')} onClick={e => { e.preventDefault(); e.stopPropagation(); }} {...rest}>
        {this.state.loading && <Spinner />}
        {!this.state.loading && !item && <div><FontIcon value="place" />{id === '' ? 'Select a location' : 'Not found'}</div>}
        {!this.state.loading && item && <div onClick={() => this.context.dialogPush('location', { id: item.get('id') })}><FontIcon value="place" />{item.get('name')}</div>}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  item: state.getIn(['locations', 'locations', props.id]),
});

export default connect(mapStateToProps)(Tag);



// WEBPACK FOOTER //
// ./app/components/Tag/Location.js